/* Wysho theme — front-end interactions (no framework) */
(function () {
  function ready(fn) {
    if (document.readyState !== 'loading') fn();
    else document.addEventListener('DOMContentLoaded', fn);
  }

  ready(function () {
    /* ---- nav drawer ---- */
    var drawer = document.querySelector('[data-wy-drawer]');
    var overlay = document.querySelector('.wy-drawer-overlay');
    function openDrawer() {
      if (!drawer) return;
      drawer.hidden = false; overlay.hidden = false;
      drawer.setAttribute('aria-hidden', 'false');
      requestAnimationFrame(function () { drawer.classList.add('is-open'); });
      document.body.style.overflow = 'hidden';
    }
    function closeDrawer() {
      if (!drawer) return;
      drawer.classList.remove('is-open');
      overlay.hidden = true;
      drawer.setAttribute('aria-hidden', 'true');
      document.body.style.overflow = '';
      setTimeout(function () { drawer.hidden = true; }, 300);
    }
    document.querySelectorAll('[data-wy-menu-open]').forEach(function (b) { b.addEventListener('click', openDrawer); });
    document.querySelectorAll('[data-wy-menu-close]').forEach(function (b) { b.addEventListener('click', closeDrawer); });
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape') closeDrawer(); });

    /* ---- hero video ---- */
    var hero = document.querySelector('.wy-home-hero__media video');
    if (hero) { hero.muted = true; hero.loop = true; hero.playsInline = true; hero.play().catch(function(){}); }

    /* ---- accordion ---- */
    document.querySelectorAll('.wy-acc__head').forEach(function (head) {
      head.addEventListener('click', function () {
        head.closest('.wy-acc__item').classList.toggle('is-open');
      });
    });

    /* ---- gallery thumbnail swap ---- */
    var main = document.querySelector('[data-wy-main-img]');
    document.querySelectorAll('[data-wy-thumb]').forEach(function (thumb) {
      thumb.addEventListener('click', function () {
        var src = thumb.getAttribute('data-src');
        if (main && src) main.setAttribute('src', src);
        document.querySelectorAll('[data-wy-thumb]').forEach(function (t) { t.classList.remove('is-active'); });
        thumb.classList.add('is-active');
      });
    });

    /* ---- bundle selector ---- */
    document.querySelectorAll('[data-wy-bundle]').forEach(function (b) {
      b.addEventListener('click', function () {
        document.querySelectorAll('[data-wy-bundle]').forEach(function (x) { x.classList.remove('is-active'); });
        b.classList.add('is-active');
        var prop = document.querySelector('[data-wy-bundle-prop]');
        if (prop) prop.value = b.getAttribute('data-bundle');
      });
    });

    /* ---- variant matching ---- */
    var form = document.querySelector('.wy-product-form');
    if (!form) return;
    var dataEl = document.querySelector('[data-wy-variants]');
    if (!dataEl) return;
    var variants = JSON.parse(dataEl.textContent || '[]');
    var idInput = form.querySelector('[name="id"]');
    var priceEl = document.querySelector('[data-wy-price]');
    var atc = form.querySelector('.wy-atc');

    function selectedOptions() {
      var opts = [];
      form.querySelectorAll('[data-wy-option]').forEach(function (el) {
        if (el.matches('select')) opts[+el.getAttribute('data-wy-option')] = el.value;
      });
      form.querySelectorAll('[data-wy-swatch].is-active').forEach(function (el) {
        opts[+el.getAttribute('data-wy-option')] = el.getAttribute('data-value');
      });
      return opts;
    }

    function update() {
      var chosen = selectedOptions();
      var match = variants.find(function (v) {
        return v.options.every(function (o, i) { return chosen[i] == null || o === chosen[i]; });
      });
      if (!match) return;
      if (idInput) idInput.value = match.id;
      if (priceEl) priceEl.textContent = match.price;
      if (atc) {
        atc.disabled = !match.available;
        if (!match.available) { atc.dataset.label = atc.textContent; atc.textContent = 'Sold out'; }
        else if (atc.dataset.label) { atc.textContent = atc.dataset.label; }
      }
    }

    form.querySelectorAll('[data-wy-swatch]').forEach(function (sw) {
      sw.addEventListener('click', function () {
        form.querySelectorAll('[data-wy-swatch][data-wy-option="' + sw.getAttribute('data-wy-option') + '"]')
          .forEach(function (x) { x.classList.remove('is-active'); });
        sw.classList.add('is-active');
        var lbl = document.querySelector('[data-wy-color-label]');
        if (lbl) lbl.textContent = sw.getAttribute('data-value');
        update();
      });
    });
    form.querySelectorAll('select[data-wy-option]').forEach(function (s) {
      s.addEventListener('change', update);
    });
    update();
  });
})();
